import { getGlobal } from "@RHCommerceDev/utils-globals/getGlobal";

const env = getGlobal("_env");

const parseUrlPath = (path: string) => {
  if (path.startsWith("http")) {
    return path;
  }

  return `https://${env.ENV_DOMAIN}${path}`;
};

export default parseUrlPath;
